import { Breadcrumbs } from "components/breadcrumbs";
import { FullScreenLoading } from "components/fullScreenLoading";
import { useOne } from "@refinedev/core";
import { IHomepageDetailData } from "interfaces";
import { AffiliateBannerForm, BlogsForm, HeroBannerForm, HotEventsForm, OrganizersForm, PromotionBannerForm, SlideBannerForm, TopBannerForm } from "./components";
import { useState } from "react";
import PreviewModal from "./components/previewModal";

export const EditHomePage : React.FC = () => {
  
  const [previewImageModalData, setPreviewImageModalData] = useState({
    isOpen: false,
    image: ""
  });

  const {
    data,
    isFetching,
    isPreviousData,
    isLoading,
  } = useOne<IHomepageDetailData>({
    resource: "content/homepage/detail",
    id: "",
    meta: {
      resource: "data",
    },
  });

  const homepageData = data?.data;

  if (isLoading) {
    return <FullScreenLoading />
  }

  if (isLoading) {
    return <FullScreenLoading />
  }

  return (
    <div className="wrapper">
      <Breadcrumbs customPageLabel="Edit Homepage" />
      {homepageData ? (
        <>
          <TopBannerForm defaultData={homepageData["ads-banner"]["top-banner"]} setPreviewImageModalData={setPreviewImageModalData} />
          <HeroBannerForm defaultData={homepageData["ads-banner"]["hero-banner"]} />
          <SlideBannerForm defaultData={homepageData["ads-banner"]["slide-banner"]} setPreviewImageModalData={setPreviewImageModalData} />
          <PromotionBannerForm defaultData={homepageData["ads-banner"]["promotion-banner"]} setPreviewImageModalData={setPreviewImageModalData} />
          <AffiliateBannerForm defaultData={homepageData["ads-banner"]["affiliate-banner"]} setPreviewImageModalData={setPreviewImageModalData} />
          <HotEventsForm defaultData={homepageData["home"]["hot-event"]} />
          <OrganizersForm defaultData={homepageData["home"]["organizer"]} />
          <BlogsForm defaultData={homepageData["blog"]} />
          <PreviewModal 
            open={previewImageModalData.isOpen} 
            onClose={() => setPreviewImageModalData({
              ...previewImageModalData,
              isOpen: false
            })} 
            data={previewImageModalData.image}
          />
        </>
      ) : <></>}
      {(isFetching && isPreviousData) ? <FullScreenLoading /> : <></>}
    </div>
  );
}